import { FeatureToggleDto } from './feature-toggle.dto';

export type FeatureToggleViewModel = {
  id: number;
  name: string;
  enabled: boolean;
  value: string | null;
};

export const toFeatureToggleViewModel = (dto: FeatureToggleDto): FeatureToggleViewModel => {
  return {
    id: dto.id,
    name: dto.name,
    enabled: dto.enabled,
    value: dto.value,
  };
};
